<template>
  <div>
    <div class="question-container">
      <div class="question-number-container">
        <img :src="leave" class="leaveImg" />
        <div class="question-number">
          {{ number }}
        </div>
      </div>
      <div class="d-flex space-between vertical-center">
        <div class="question-text-container">
          <h1 class="question-text">
            {{ question }}
          </h1>
          <p class="paragraph z-1000" v-html="comment"></p>
        </div>
        <div class="info-img" v-if="modalActivator">
          <img :src="infoImg" @click="$emit('activateModal')" v-if="!modalActive" />
          <img :src="savoirPlusImg" @click="$emit('activateModal')" v-if="modalActive" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      leave: require("@/assets/images/feuille.png"),
      infoImg: require("@/assets/images/info.png"),
      savoirPlusImg: require("@/assets/images/ensavoirplus.png"),
    };
  },
  props: {
    number: String,
    question: String,
    comment: String,
    modalActivator: { type: Boolean, default: false },
    modalActive: { type: Boolean, default: false }
  },
};
</script>
<style scoped>
.question-container {
  position: relative;
  width: 90%;
  max-width: 1600px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  height: 100%;
}

.leaveImg {
  max-width: 240px;
}

.question-number-container {
  position: relative;
}
.paragraph{
    font-size:27px;
  }
.question-number {
  color: var(--text-color);
  font-family: var(--font);
  font-size: 18rem;
  font-style: normal;
  font-weight: 900;
  line-height: 1em;
  opacity: 0.25;
  position: absolute;
  top: 50%;
  left: 50%;
  translate: -50% -50%;
}

.question-text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: -3%;
}

.question-text {
  color: var(--text-color);
  font-family: var(--font);
  font-size: 4.2rem;
  line-height: 1.1em;
  font-style: normal;
  font-weight: 600;
  z-index: 1000;
  margin-bottom: 0px;
}

.comment-text {
  margin-top: 0;
  color: var(--text-color);
  font-family: var(--font);
  font-size: 2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 44.2px;
  z-index: 1000;
}


.z-1000 {
  z-index: 1000;
}

@media screen and (max-width: 1400px) {
  .leaveImg {
    max-width: 160px;
  }

  .question-text {
    font-size: 2.5rem;
    line-height: 1.1em;
  }
  .paragraph{
    font-size:25px;
  }
  .text-container-header {
    left: 55px;
  }

  .question-number {
    font-size: 10rem;
  }


}

@media screen and (max-width: 900px) {
  .question-text {
    font-size: 1.5rem;
    line-height: 1.1em;
  }
  .paragraph{
    font-size:16px;
  }
  .leaveImg {
    max-width: 120px;
  }

}

@media screen and (max-width: 600px) {
  .leaveImg {
    max-width: 110px;
  }

  .question-text {
    font-size: 1.7rem;
    line-height: 1.1em;
  }

  .text-container-header {
    left: 55px;
  }

  .question-number {
    font-size: 10rem;
  }

 
}
</style>
